import React, { Component } from 'react'
import { withFirebase } from '../../components/Fb'

// reactstrap components
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
} from 'reactstrap'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  // FormControlLabel,
  // FormGroup,
  // Switch,
  Typography,
} from '@mui/material'
import FalconModal from '../../components/Inputs/FalconModal'
import {
  getCoachingBreakSchema,
  getCoachingBreakUiSchema,
  getCoachingClassSchema,
  getCoachingClassUiSchema,
  getCoachingLevelSchema,
  getCoachingLevelUiSchema,
  getCoachingPricingsSchema,
  getCoachingPricingsUiSchema,
  getCoachingSeasonSchema,
  getCoachingSeasonUiSchema,
} from '../../components/Inputs/dataschemas'
import EditButton from '../../components/Buttons/EditButton'
import DeleteButton from '../../components/Buttons/DeleteButton'
import WarningIcon from '@mui/icons-material/Warning'
import FormDesigner from '../../components/Inputs/FormDesigner'

function ErrorIcon({ text }) {
  return (
    <Tooltip title={text} arrow>
      <WarningIcon color='error' style={{ marginRight: 10, marginLeft: 10 }} />
    </Tooltip>
  )
}

function Seasons({ seasons, firebase, onChanced, applications, classes }) {
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [selected, setSelected] = React.useState({})
  const [saving, setSaving] = React.useState(false)
  if (!seasons) return (seasons = [])

  const deleteSeason = async (seasonId) => {
    setSaving(true)
    await firebase.deleteCoachingSeason(seasonId)
    onChanced('seasons')
    setSaving(false)
  }

  const createSeason = async (season) => {
    setSaving(true)
    await firebase.createCoachingSeason(season)
    onChanced('seasons')
    setSaving(false)
  }

  const updateSeason = async (season) => {
    setSaving(true)
    await firebase.updateCoachingSeason(season)
    onChanced('seasons')
    setSaving(false)
  }

  const getSchema = () => {
    const seasonSchema = getCoachingSeasonSchema()
    console.log('Applications for season schema:', seasonSchema)
    delete seasonSchema.properties.applicationid.enum
    seasonSchema.properties.applicationid.oneOf = applications.map(a => ({ const: a.id, title: a.title }))
    delete seasonSchema.properties.classes.items.enum
    seasonSchema.properties.classes.items.oneOf = classes.map(c => ({ const: c.id, title: c.name }))
    return seasonSchema
  }

  return (
    <div>
      <Card>
        <CardHeader>
          <Row>
            <Col lg='10' md='5' sm='5'>
              <CardTitle tag='h5'>Valmennuskaudet</CardTitle>
            </Col>
            <Col className='text-right'>
              <Button
                color='primary'
                size='sm'
                onClick={() => setDialogOpen(true)}
              >
                Lisää uusi
              </Button>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Nimi</th>
                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  Alkaa
                </th>
                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  Loppuu
                </th>
                <th>Tila</th>
                <th>Toiminnot</th>
              </tr>
            </thead>
            <tbody>
              {seasons && seasons.length > 0 ? (
                seasons.map((season) => (
                  <tr key={season.id}>
                    <td>
                      {season.applicationid ? (
                        ''
                      ) : (
                        <ErrorIcon text={'Ilmoittautuminen puuttuu'} />
                      )}
                    </td>
                    <td>{season.name}</td>
                    <td style={{ paddingLeft: 20, paddingRight: 10 }}>
                      {new Date(Date.parse(season.start)).toLocaleDateString()}
                    </td>
                    <td style={{ paddingLeft: 20, paddingRight: 10 }}>
                      {new Date(Date.parse(season.end)).toLocaleDateString()}
                    </td>
                    <td style={{ paddingLeft: 20, paddingRight: 10 }}>
                      {season.state === 'active' ? (
                        'Aktiivinen/Lukittu'
                      ) : season.state === 'draft' ? (
                        'Luonnos'
                      ) : season.state === 'archived' ? (
                        'Arkistoitu'
                      ) : season.state === 'deleted' ? (
                        'Poistettu'
                      ) : (
                        season.state
                      )}
                    </td>
                    <td>
                      <EditButton
                        onClick={() => {
                          setSelected(season)
                          setDialogOpen(true)
                        }}
                        loading={saving}
                        disablediv={true}
                      >
                        Muokkaa
                      </EditButton>
                      <DeleteButton
                        onClick={async () => {
                          await deleteSeason(season.id)
                        }}
                        loading={saving}
                        disablediv={true}
                      >
                        Poista
                      </DeleteButton>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3}>Ei valmennuskausia</td>
                </tr>
              )}
            </tbody>
          </table>
          {/* {seasons.map((season) => (
            <Row key={season.id}>
              <Col>
                <Typography variant='h6'>Nimi: {season.name}</Typography>
              </Col>
              <Col>
                <Typography variant='h6'>
                  Alkaa: {season.start.toDate().toString()}
                </Typography>
              </Col>
              <Col>
                <Typography variant='h6'>
                  Loppuu: {season.end.toDate().toString()}
                </Typography>
              </Col>
            </Row>
          ))} */}

          {/* {saving ? (
            <p>Tallennetaan...</p>
          ) : (
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={true}
                    // onChange={this.onCustomerviewChange}
                    name='0'
                    color='primary'
                    inputProps={{ 'aria-label': 'primary checkbox controlled' }}
                  />
                }
                label='Näkyvissä asiakkaille'
              />
            </FormGroup>
          )} */}
        </CardBody>
      </Card>
      <FalconModal
        isOpen={dialogOpen}
        title='Muokkaa valmennuskautta'
        toggle={() => {
          setSelected({})
          setDialogOpen(!dialogOpen)
        }}
        onUpdate={updateSeason}
        onCreate={createSeason}
        resource={selected}
        uiSchema={getCoachingSeasonUiSchema()}
        dataSchema={getSchema()}
      />
    </div>
  )
}

function Classes({ classes, firebase, onChanced }) {
  const [selected, setSelected] = React.useState(null)
  const [saving, setSaving] = React.useState(false)
  const [dialogOpen, setDialogOpen] = React.useState(false)

  const createClass = async (cls) => {
    setSaving(true)
    await firebase.createCoachingClass(cls)
    onChanced('classes')
    setSaving(false)
  }

  const updateClass = async (cls) => {
    setSaving(true)
    await firebase.updateCoachingClass(cls)
    onChanced('classes')
    setSaving(false)
  }

  const deleteClass = async (classId) => {
    setSaving(true)
    await firebase.deleteCoachingClass(classId)
    onChanced('classes')
    setSaving(false)
  }

  return (
    <div>
      <Card>
        <CardHeader>
          <Row>
            <Col className='auto'>
              <CardTitle tag='h5'>Valmennuskokonaisuudet / Joukkueet</CardTitle>
            </Col>
            <Col className='text-right'>
              <Button
                color='primary'
                size='sm'
                onClick={() => setDialogOpen(true)}
              >
                Lisää uusi
              </Button>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          {classes && classes.length > 0 ? (
            classes.map((cls) => (
              <Row key={cls.id}>
                <Col>
                  <Typography
                    variant='body1'
                    component='span'
                    style={{ marginRight: 20 }}
                  >
                    {cls.name}{' '}
                    {cls.state !== 'active' ? (
                      <ErrorIcon text={'ei aktiivinen'} />
                    ) : (
                      ''
                    )}
                  </Typography>
                  <EditButton
                    onClick={() => {
                      setSelected(cls)
                      setDialogOpen(true)
                    }}
                    loading={saving}
                    disablediv={true}
                  >
                    Muokkaa
                  </EditButton>
                  <DeleteButton
                    onClick={async () => {
                      await deleteClass(cls.id)
                    }}
                    loading={saving}
                    disablediv={true}
                  >
                    Poista
                  </DeleteButton>
                </Col>
              </Row>
            ))
          ) : (
            <p>Ei valmennus kokonaisuuksia / joukkueita</p>
          )}

          {/* {saving ? (
            <p>Tallennetaan...</p>
          ) : (
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={true}
                    // onChange={this.onCustomerviewChange}
                    name='0'
                    color='primary'
                    inputProps={{ 'aria-label': 'primary checkbox controlled' }}
                  />
                }
                label='Näkyvissä asiakkaille'
              />
            </FormGroup>
          )} */}
        </CardBody>
      </Card>
      <FalconModal
        isOpen={dialogOpen}
        title='Lisää valmennuskokonaisuus / joukkue'
        toggle={() => setDialogOpen(!dialogOpen)}
        onUpdate={updateClass}
        onCreate={createClass}
        resource={selected}
        uiSchema={getCoachingClassUiSchema()}
        dataSchema={getCoachingClassSchema()}
      />
      {/* <CoachingClassForm
          firebase={firebase}
          toggle={() => setDialogOpen(!dialogOpen)}
        /> */}
    </div>
  )
}

function Pricings({ pricings, firebase, onChanced, seasons, classes }) {
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [selected, setSelected] = React.useState(null)
  const [saving, setSaving] = React.useState(false)

  const deletePricing = async (pricingId) => {
    setSaving(true)
    await firebase.deleteResourcePricing(pricingId)
    onChanced('pricings')
    setSaving(false)
  }

  const createPricing = async (pricing) => {
    setSaving(true)
    await firebase.addResourcePricings(pricing)
    onChanced('pricings')
    setSaving(false)
  }

  const updatePricing = async (pricing) => {
    setSaving(true)
    await firebase.updateResourcePricing(pricing)
    onChanced('pricings')
    setSaving(false)
  }

  return (
    <div>
      <Card>
        <CardHeader>
          <Row>
            <Col lg='10' md='5' sm='5'>
              <CardTitle tag='h5'>Valmennuksen hinnoittelut</CardTitle>
            </Col>
            <Col className='text-right'>
              <Button
                color='primary'
                size='sm'
                onClick={() => setDialogOpen(true)}
              >
                Lisää uusi
              </Button>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <table>
            <thead>
              <tr>
                <th>Valmennuskokonaisuus</th>
                <th>Kausi</th>
                <th>Hinta (€)</th>
                <th>Toiminnot</th>
              </tr>
            </thead>
            <tbody>
              {pricings && pricings.length > 0 ? (
                pricings.map((pricing) => (
                  <tr key={pricing.id}>
                    <td>{classes.find((c) => c.id === pricing.class).name}</td>
                    <td>{seasons.find((s) => s.id === pricing.season).name}</td>
                    <td>{pricing.price}</td>
                    <td>
                      <EditButton
                        onClick={() => {
                          setSelected(pricing)
                          setDialogOpen(true)
                        }}
                        loading={saving}
                        disablediv={true}
                      >
                        Muokkaa
                      </EditButton>
                      <DeleteButton
                        onClick={async () => {
                          await deletePricing(pricing.id)
                        }}
                        loading={saving}
                        disablediv={true}
                      >
                        Poista
                      </DeleteButton>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4}>Ei valmennuksen hinnoitteluita</td>
                </tr>
              )}
            </tbody>
          </table>
        </CardBody>
      </Card>
      <FalconModal
        isOpen={selected !== null || dialogOpen}
        title='Muokkaa valmennuksen hinnoittelua'
        toggle={() => {
          setSelected(null)
          setDialogOpen(!dialogOpen)
        }}
        onUpdate={updatePricing}
        onCreate={createPricing}
        resource={selected}
        uiSchema={getCoachingPricingsUiSchema()}
        dataSchema={getCoachingPricingsSchema()}
      />
    </div>
  )
}

function Applications({ applications, seasons, onOpenEditor }) {
  const openApplication = (id) => {
    const app = applications.find((a) => a.id === id)
    if (app) {
      onOpenEditor(app, false)
    }
  }

  const createNewApplicationForm = () => {
    onOpenEditor(null, true)
  }

  return (
    <div>
      <Card>
        <CardHeader>
          <Row>
            <Col lg='10' md='5' sm='5'>
              <CardTitle tag='h5'>
                Valmennushakemukset/ilmoittautumislomakkeet
              </CardTitle>
            </Col>
            <Col className='text-right'>
              <Button
                color='primary'
                size='sm'
                onClick={() => createNewApplicationForm()}
              >
                Lisää uusi
              </Button>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          {applications && applications.length > 0 ? (
            applications.map((application) => (
              <Row key={application.id}>
                <Col>
                  <Typography
                    variant='body1'
                    component='span'
                    style={{ marginRight: 20 }}
                  >
                    {application.title} -{' '}
                    {seasons.find((s) => s.id === application.season)?.name ||
                      <><ErrorIcon text={'ei kautta valittu'} />Ei kautta valittu</>}
                  </Typography>
                </Col>
                <Col>
                  {/* <Button
                    color='info'
                    size='sm'
                    onClick={() => openApplication(application.id)}
                  >
                    {' '}
                    Avaa
                  </Button> */}
                  <EditButton
                    onClick={() => openApplication(application.id)}
                    loading={false}
                    disablediv={true}
                  >
                    Muokkaa
                  </EditButton>
                  <DeleteButton
                    onClick={async () => {
                      // await deletePricing(pricing.id)
                    }}
                    loading={false}
                    disablediv={true}
                  >
                    Poista
                  </DeleteButton>
                </Col>
              </Row>
            ))
          ) : (
            <p>Ei valmennushakemuksia</p>
          )}
        </CardBody>
      </Card>
    </div>
  )
}

class CoachingSeasonSettingsContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      seasons: [],
      levels: [],
      classes: [],
      breaks: [],
      formEditorOpen: false,
      pricings: [],
      applications: [],
    }
  }

  onChanced = (collection) => {
    if (collection === 'levels') {
      this.props.firebase.getCoachingLevels().then((levels) => {
        this.setState({ levels })
      })
    } else if (collection === 'seasons') {
      this.props.firebase.getCoachingSeasons().then((seasons) => {
        seasons.sort((a, b) => {
          return new Date(a.start) - new Date(b.start)
        })
        this.setState({ seasons })
      })
    } else if (collection === 'classes') {
      this.props.firebase.getCoachingClasses().then((classes) => {
        this.setState({ classes })
      })
    } else if (collection === 'breaks') {
      this.props.firebase.getCoachingBreaks().then((breaks) => {
        breaks.sort((a, b) => {
          return new Date(Date.parse(a.start)) - new Date(Date.parse(b.start))
        })
        this.setState({ breaks })
      })
    } else if (collection === 'pricings') {
      this.props.firebase.getCoachingPricings().then((pricings) => {
        this.setState({ pricings })
      })
    } else if (collection === 'applications') {
      this.props.firebase.getCoachingApplications().then((applications) => {
        this.setState({ applications })
      })
    }
  }

  async componentDidMount() {
    console.log('Fetching coaching seasons...')
    const [seasons, levels, classes, breaks, pricings, applications] =
      await Promise.all([
        this.props.firebase.getCoachingSeasons(),
        this.props.firebase.getCoachingLevels(),
        this.props.firebase.getCoachingClasses(),
        this.props.firebase.getCoachingBreaks(),
        this.props.firebase.getCoachingPricings(),
        this.props.firebase.getCoachingApplications(),
      ])
    breaks.sort((a, b) => {
      return new Date(Date.parse(a.start)) - new Date(Date.parse(b.start))
    })
    seasons.sort((a, b) => {
      return new Date(a.start) - new Date(b.start)
    })
    this.setState({ seasons, levels, classes, breaks, pricings, applications })
  }

  onOpenFormEditor = (formData, create) => {
    if (create) {
      this.setState({ formEditorOpen: true, formData: null })
      return
    } else {
      this.setState({ formEditorOpen: true, formData })
    }
  }

  saveFormData = (formData) => {
    if (!formData.id) {
      this.props.firebase.createCoachingApplication(formData).then((saved) => {
        console.log('Saved new application', saved, saved.id)
        // get new id
        formData.id = saved.id
        this.setState({ formData: formData })
        this.onChanced('applications')
      })
      return
    } else {
      this.props.firebase.updateCoachingApplication(formData).then(() => {
        this.onChanced('applications')
      })
    }
  }

  render() {
    if (this.state.formEditorOpen) {
      return (
        <>
          <div className='content'>
            <FormDesigner
              seasons={this.state.seasons}
              formdata={this.state.formData}
              onChange={(formData) => this.setState({ formData })}
              onSave={this.saveFormData}
              onClose={() => this.setState({ formEditorOpen: false, formData: null })}
            />
          </div>
        </>
      )
    }
    return (
      <>
        <div className='content'>
          <Row>
            <Col md='12'>
              <Classes
                classes={this.state.classes}
                firebase={this.props.firebase}
                onChanced={this.onChanced}
              />
            </Col>
          </Row>
          <Row>
            <Col md='12'>
              <Seasons
                classes={this.state.classes}
                seasons={this.state.seasons}
                firebase={this.props.firebase}
                applications={this.state.applications}
                onChanced={this.onChanced}
              />
            </Col>
          </Row>
          <Row>
            <Col md='12'>
              <Pricings
                pricings={this.state.pricings}
                firebase={this.props.firebase}
                onChanced={this.onChanced}
                classes={this.state.classes}
                seasons={this.state.seasons}
              />
            </Col>
          </Row>
          <Row>
            <Col md='12'>
              <Applications
                applications={this.state.applications}
                firebase={this.props.firebase}
                onChanced={this.onChanced}
                seasons={this.state.seasons}
                onOpenEditor={this.onOpenFormEditor}
              />
            </Col>
          </Row>
          <Row>
            <Col
              className='text-center'
              md='12'
              style={{ marginTop: 20, marginBottom: 50 }}
            >
            </Col>
          </Row>
        </div>
      </>
    )
  }
}

export default withFirebase(CoachingSeasonSettingsContainer)
